import GameAssignments from "./GameAssignments";

export default GameAssignments;